/**
 * Cart quantity limit — client-side UX layer that works WITH Minimog's native cart.
 * Caps how many of a product (scope 'product') or how many items total (scope 'cart')
 * may be in the cart. It does not fight the theme: native steppers and add-to-cart behave
 * normally, then after each cart update any over-limit line is brought back down via the
 * theme's own update method and a friendly message is shown.
 *
 * Config (set inline in layout/theme.liquid from theme settings):
 *   window.MinimogQtyLimit = { max: Number, scope: 'product' | 'cart', message: String }
 *   message tokens: [max] = the limit, [remaining] = how many more are allowed.
 *
 * NOTE: This is the friendly client-side layer and can be bypassed. Authoritative,
 * un-bypassable enforcement (including at checkout) is handled by the companion
 * Cart & Checkout Validation Function.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var CONFIG = window.MinimogQtyLimit || {};
    var MAX_QUANTITY = parseInt(CONFIG.max, 10);
    if (!MAX_QUANTITY || MAX_QUANTITY < 1) return;

    var SCOPE = CONFIG.scope === 'cart' ? 'cart' : 'product';
    var MESSAGE = CONFIG.message || 'Only [max] of each item is allowed per order.';
    function rootUrl() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function getCart() {
      return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .catch(function () { return null; });
    }

    var lastNotify = { message: '', at: 0 };
    function notify(remaining) {
      var text = String(MESSAGE).replace(/\[max\]/g, MAX_QUANTITY).replace(/\[remaining\]/g, Math.max(0, remaining));
      var now = Date.now();
      if (text === lastNotify.message && now - lastNotify.at < 2500) return; // de-dupe
      lastNotify = { message: text, at: now };
      if (window.MinimogTheme && window.MinimogTheme.Notification && typeof window.MinimogTheme.Notification.show === 'function') {
        window.MinimogTheme.Notification.show({ target: document.body, method: 'appendChild', type: 'warning', message: text, last: 3500 });
      }
    }

    // The Minimog cart component whose UI is currently on screen.
    function visibleCartComponent() {
      var drawer = document.querySelector('m-cart-drawer');
      if (drawer && drawer.classList.contains('m-cart-drawer--active')) {
        var drawerItems = document.querySelector('m-cart-drawer-items');
        if (drawerItems) return drawerItems;
      }
      return document.querySelector('m-cart') || document.querySelector('m-cart-drawer-items');
    }

    // Server-side fallback if the native cart component isn't available.
    function bareChange(variantId, qty) {
      return fetch(rootUrl() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
    }

    // ---- Enforce the limit by reconciling AFTER Minimog's own cart updates ----
    // We do NOT touch the native steppers or add-to-cart (so increase/decrease work
    // normally). After any cart change, if a line (scope 'product') or the whole cart
    // (scope 'cart') is over the limit, we ask the theme's own cart component to bring
    // the quantity back down — which re-renders the UI correctly — and show a message.
    var correcting = false;

    function reconcile() {
      if (correcting) return;
      getCart().then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;

        var fix = null; // { line: 1-based index, variantId, target }
        if (SCOPE === 'product') {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].quantity > MAX_QUANTITY) {
              fix = { line: i + 1, variantId: cart.items[i].variant_id, target: MAX_QUANTITY };
              break;
            }
          }
        } else {
          var total = cart.items.reduce(function (sum, it) { return sum + it.quantity; }, 0);
          if (total > MAX_QUANTITY) {
            var last = cart.items[cart.items.length - 1];
            fix = { line: cart.items.length, variantId: last.variant_id, target: Math.max(0, last.quantity - (total - MAX_QUANTITY)) };
          }
        }
        if (!fix) return;

        correcting = true;
        notify(0);

        var done = false;
        try {
          var comp = visibleCartComponent();
          if (comp && typeof comp.updateQuantity === 'function') {
            comp.updateQuantity(fix.line, fix.target);
            done = true;
          }
        } catch (e) { done = false; }

        if (!done) {
          bareChange(fix.variantId, fix.target).then(function () {
            if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
              getCart().then(function (fresh) {
                window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, fresh || {});
              });
            }
          });
        }

        setTimeout(function () { correcting = false; }, 1000);
      });
    }

    // Re-check after every theme cart update: stepper change, add to cart, quick add, drawer add.
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function () {
        setTimeout(reconcile, 200);
      });
    }
    document.addEventListener('cart:updated', function () { setTimeout(reconcile, 200); });

    // Correct any pre-existing over-limit cart on first load.
    setTimeout(reconcile, 600);
  });
})();
